<p-panel>
    <app-reactive-form-builder
      #formbuilder
      (stableValueChanges)="stableValueChanges($event)"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [id]="reactiveFormRecordId"
      [request]="request"
      [getRequest]="fincasApi.fincasGET">
    </app-reactive-form-builder>
</p-panel>

@if (showReaImportDialog) {
  <app-rea-import-modal
    [visible]="showReaImportDialog"
    (visibleChange)="onReaDialogVisibilityChange($event)"
    [model]="buildReaModalModel()"
    (imported)="onReaImported($event)">
  </app-rea-import-modal>
}